import store from '@/config/store'
import channelService from '@/services/amio-api/channel.service'
import integrationService from '@/services/amio-api/integration.service'

function prepareIntegration(to, next, callback) {
  const integrationId = to.params.id
  const integration = store.administration.integrationDetail.integration
  const isIntegrationAlreadyLoaded = integration.id === integrationId
  if (isIntegrationAlreadyLoaded) return next()

  integrationService.get(integrationId, [404])
    .then(integration => {
      next(vm => callback(vm, integration))
    })
    .catch(() => next('/not-found'))
}

function prepareChannel(to, next, callback) {
  const channelId = to.params.id
  const channel = store.administration.channelDetail.channel
  const isChannelAlreadyLoaded = channel.id === channelId
  if (isChannelAlreadyLoaded) return next(vm => callback(vm, channel))

  channelService.get(channelId, [404])
    .then(channel => {
      next(vm => callback(vm, channel))
    })
    .catch(() => next('/not-found'))
}

export {
  prepareChannel,
  prepareIntegration
}
